import React from 'react';
import { useParams } from 'react-router-dom';
import AuthLayout from '../../layouts/AuthLayout/AuthLayout';
import AdsForm from '../../components/forms/AdsForm/AdsForm';

const Ads = () => {

  const { uid } = useParams();

  return (
    <AuthLayout pageName="ads">
      <AdsForm userId={uid} />
    </AuthLayout>
  );
};

export default Ads;
